import * as React from "react"
import {ButtonLoadingSeeker, IconSeeker} from "@ui-seeker/core";
import {Box} from "@mui/material";


export default function ActionButton({ isLoading=false, label, color='primary', onClick, icon, ...props }) {
	return <Box className={isLoading ? "is-loading" : ""}>
		<ButtonLoadingSeeker
			loading={isLoading}
			size="small"
			color={color}
			startIcon={icon && <IconSeeker icon={icon} />}
			onClick={onClick}
			{...props}
		>
			{label}
		</ButtonLoadingSeeker>
	</Box>
}